export default __webpack_public_path__ + "static/media/project1.4a16673b.png";